import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { map } from 'lodash';
import {
  IconButton,
  withStyles,
} from '@material-ui/core';
import {
  DragIndicator,
} from '@material-ui/icons';
import { useDrag } from 'react-dnd';
import compose from 'recompose/compose';
import styles from './styles';
import {
  ENTITY_PICKER_TYPE_CATEGORY,
  ENTITY_PICKER_TYPE_TEMPLATE,
} from '../constants';

export const Entity = ({ categoryIndex, classes, entity, onDrag, type }) => {
  const [{ isDragging }, drag] = useDrag({
    item: {
      categoryIndex,
      id: entity.uuid,
      type,
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });
  useEffect(() => {
    // Todo: looks like a bug in react-dnd
    // Looks like it is getting called after unmount
    if (onDrag) {
      onDrag(isDragging);
    }
  }, [isDragging]);
  const entityRowClasses = clsx(classes.entityRow,
    (type !== ENTITY_PICKER_TYPE_TEMPLATE) ? classes.categoryEntityRow : '');
  return (
    <div
      className={entityRowClasses}
      data-apim-test={`entity-${entity.uuid}`}
      key={entity.uuid}
      ref={drag}
    >
      <IconButton
        className={classes.iconRoot}
        size="small"
      >
        <DragIndicator />
      </IconButton>
      {entity.name}
    </div>
  );
};

Entity.propTypes = {
  categoryIndex: PropTypes.number,
  classes: PropTypes.object,
  entity: PropTypes.object,
  onDrag: PropTypes.func,
  type: PropTypes.string,
};

export const EntityPicker =
  ({ categoryIndex, classes, entities, hasError, message, onDrag, type }) => {
  const renderEntity = (entity) =>
    (<Entity
      categoryIndex={categoryIndex}
      classes={classes}
      entity={entity}
      key={entity.uuid}
      onDrag={onDrag}
      type={type}
    />);
  const containerClasses = clsx(classes.container,
    hasError ? classes.errorContainer : classes.infoContainer,
  );
  const containerWrapperClasses = (type !== ENTITY_PICKER_TYPE_TEMPLATE) ? classes.categoryWrapper : '';
  const titleClasses = clsx(classes.titleRow,
    hasError ? classes.errorTitle : classes.infoTitle);
  return(
    <div className={containerWrapperClasses}>
      <div
        className={containerClasses}
        data-apim-test={ type === ENTITY_PICKER_TYPE_CATEGORY ?
          ENTITY_PICKER_TYPE_CATEGORY : ENTITY_PICKER_TYPE_TEMPLATE
        }
      >
        <div className={titleClasses}>
          <div>{message}</div>
        </div>
        {map(entities, renderEntity)}
      </div>
    </div>
  );
};

EntityPicker.propTypes = {
  categoryIndex: PropTypes.number,
  classes: PropTypes.object,
  entities: PropTypes.array,
  hasError: PropTypes.bool,
  message: PropTypes.string,
  onDrag: PropTypes.func,
  type: PropTypes.string,
};

EntityPicker.displayName = 'EntityPicker';

export default compose(
  withStyles(styles),
)(EntityPicker);